import { Helmet } from "react-helmet-async";
import ContactFirst from "../../components/contact/contactFirst/ContactFirst.tsx";
import ContactSecond from "../../components/contact/contactSecond/ContactSecond.tsx";
import Banner from "../../components/banner/Banner.tsx";

const Contact = () => {
  return (
    <div>
      {/* SEO */}
      <Helmet>
        <title>Contactez-nous - VRN Innovation</title>
        <meta
          name="description"
          content="Besoin d'informations ou d'un devis ? Contactez VRN Innovation à Douala pour vos projets en développement web, mobile, réseaux, sécurité, domotique, Starlink et consulting IT."
        />
        <meta
          name="keywords"
          content="Contact VRN Innovation, Développement web Douala, Développement mobile Cameroun, Installation Starlink, Réseaux informatiques, Caméras de surveillance, Domotique, Consulting IT"
        />
        <link rel="canonical" href="https://www.vrn-innovation.com/contact" />
      </Helmet>
      <Banner
        title="Contact"
        breadcrumbs={[{ label: "Accueil", link: "/" }, { label: "Contact" }]}
      />
      <ContactFirst />
      <ContactSecond />
    </div>
  );
};

export default Contact;
